// extracted by mini-css-extract-plugin
export default {"general":"styles_general__kxxBw","divider":"styles_divider__SMPJB"};